import { posAppVersion } from './../app/models/models';
import { IEnvironment } from "src/app/models/models";

const database = {
    apiKey: "AIzaSyBmfb5lbJ29AdVQyp0Jk1Tug6pekx_fTwA",
    authDomain: "pq2-staging.firebaseapp.com",
    databaseURL: "https://pq2-staging.firebaseio.com",
    projectId: "pq2-staging",
    storageBucket: "pq2-staging.appspot.com",
    messagingSenderId: "438992683153"
};
export const environment: IEnvironment = {
    production: false,
    // Receipts SQL-SoT P4c: unit stats from /v1/stats/v2 (SQL rollups + live day) instead of
    // Firestore statistics_v3 + a browser-computed "today". Override per browser: ?statsV2=on|off.
    statsV2: true,
    database: database,
    primeApiUrl: "https://us-central1-joboffice-prime-staging.cloudfunctions.net",
    pubQueueApiUrl: "https://us-central1-pq2-staging.cloudfunctions.net",
    pubQueueApiUrlEU: "https://dashboard2-ue6wk323oq-ew.a.run.app",
    adminAppUrl: "https://admin-staging.pubq.se",
    posUrl: "https://pos-staging.pubq.se",
    kdsUrl: "https://console.firebase.google.com/project/pq2-staging/database/pq2-staging/data",
    netsApiUrl: "https://connectcloud-test.aws.nets.eu",
    pubQPosApi: "https://pos2-ue6wk323oq-ew.a.run.app",
    publicApiUrl: "https://europe-west1-pq2-staging.cloudfunctions.net/api",
    // Z-rapporter -> Fortnox (pubq-functions fortnoxZApi). Prod: environment.prod.ts.
    fortnoxZApiUrl: "https://europe-west1-pq2-staging.cloudfunctions.net/fortnoxZApi",
    // Catering backend (pubq-functions cateringApi); Admin writes partner-group companies through it.
    cateringApiUrl: "https://europe-west1-pq2-staging.cloudfunctions.net/cateringApi",
    posAppVersion: posAppVersion,
    paymentTerminalUrl: "http://localhost:5009/api",
    paymentTerminalUrl_ws: "ws://localhost:5009/api",
    paymentsApiUrl: "https://payments2-ue6wk323oq-ew.a.run.app",
    staffApiUrl: "https://europe-west1-pq2-staging.cloudfunctions.net/staffApi",

};
